import { useCallback, useEffect, useState } from 'react';

import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import {
  detailActions,
  detailSelectors,
} from 'store/reducers/crawlerReducer/detailSlice';
import { useListStore } from './useListStore';

/**
 * クローラー詳細 store の実装をコンポーネントから隠すための中間層
 * @returns selector と action のラッパー
 */
export const useDetailStore = () => {
  const dispatch = useAppDispatch();
  const selectedCrawler = useAppSelector(detailSelectors.selectedCrawler);
  const crawlerDetails = useAppSelector(detailSelectors.selectedCrawlerDetails);
  const [canDeleteCrawler, setCanDeleteCrawler] = useState<boolean>(false);
  const { fetchCrawlers } = useListStore();

  useEffect(() => {
    setCanDeleteCrawler(crawlerDetails.length === 0);
  }, [crawlerDetails]);

  const onCloseModalDetail = useCallback(() => {
    void fetchCrawlers();
    dispatch(detailActions.initialize());
  }, [dispatch, fetchCrawlers]);

  const onOpenModalDelete = useCallback(() => {
    dispatch(detailActions.updateIsOpenModalDelete(true));
  }, [dispatch]);

  return {
    /** 選択中のクローラー */
    selectedCrawler,
    /** 削除可能フラグ */
    canDeleteCrawler,
    /** クローラー詳細モーダルの表示状態 */
    isOpenModal: !!selectedCrawler,
    /** クローラー詳細を閉じる */
    onCloseModalDetail,
    /** クローラーの削除確認モーダルを表示 */
    onOpenModalDelete,
  };
};
